/* eslint-disable */

import $ from "jquery";

class MegaMenuNavigation {
    constructor()
    {
        // top menu links
        this.navItems = null;

        // container of dropdown-links (div tag) and activeMegaMenu
        this.megaMenu = document.querySelector(".megamenu");

        // top menu link (a tag)
        this.activeNavItem = null;

        // container (data-menuset="%d") (div tag)
        this.activeMegaMenu = null;

        // populate top menu (a tag) links `.navItems` with dom elements
        this.getLinks();

        // apply click event on top menu links `.navItems` to call `toggleNav(el, event)`
        this.bindEventHandlers();
    }

    getLinks()
    {
        this.navItems = document.querySelectorAll("a[data-megamenu]");
    }

    closeMenu(event)
    {
        if (this.activeNavItem && this.activeMegaMenu) {
            if (
            !this.activeMegaMenu.contains(event.target) &&
            !this.activeNavItem.contains(event.target)
            ) {
                this.closeActiveMenus();
                this.removeClickListener();
            }
        }
    }

    removeClickListener()
    {
        document.removeEventListener("click", this.closeMenu);
    }

    closeActiveMenus()
    {
        // Close any active mega menus
        if (this.activeNavItem && this.activeMegaMenu) {
            this.activeNavItem.parentNode.classList.remove("active");
            this.activeNavItem.setAttribute("aria-expanded", "false");
            this.activeMegaMenu.classList.remove("active");
            this.activeMegaMenu.setAttribute("aria-expanded", "false");
            $(this.activeMegaMenu).children().removeClass("container-active");
            $(".megamenu").removeClass("active");
            $(".megamenu-menuset").removeAttr("style");
        }
    }

    resizeMenu()
    {
        $(window).resize(() => {
            this.closeActiveMenus();
        });
    }

    megaMenuTabIndex()
    {
        const nav = $("main");
        const focusableEls = nav.find('[href]');
        const firstFocusableEls = focusableEls.first()[0];
        $(firstFocusableEls).attr("tabindex", "0");

        $(firstFocusableEls).on("focus", () => {
            this.closeActiveMenus();
        });
    }

    toggleNav(el, event)
    {
        const menuID = el.dataset.megamenu;
        const menuSet = document.querySelector(`div[data-menuset="${menuID}"]`);
        const target = event.target.tagName.toLowerCase() === 'a'
            ? event.target
            : event.target.parentNode;

        // Close any active menus
        this.closeActiveMenus();

        if (menuSet !== null) {
            // Check we're not clicking on our own nav
            // close if we're clicking self

            if (target === this.activeNavItem) {
                this.activeNavItem = null;
                this.activeMegaMenu = null;
                const menuOffset = document
                  .querySelector(".megamenu-menuset")
                  .getBoundingClientRect().left + "px";
                const leftOffset = "-" + menuOffset;
                menuSet.style.left = leftOffset;
            } else {
                this.megaMenuTabIndex();
                $(menuSet).width($(window).width());
                el.parentNode.classList.add("active");

                if (el.parentNode.classList.contains("active")) {
                    $(el).next().addClass("active");
                    menuSet.firstElementChild.classList.add("container-active");
                }

                el.setAttribute("aria-expanded", "true");
                menuSet.classList.add("active");
                menuSet.setAttribute("aria-expanded", "true");

                const menuOffset = document.querySelector(".megamenu-menuset.active").getBoundingClientRect().left + "px";
                const leftOffset = "-" + menuOffset;
                menuSet.style.left = leftOffset;
                this.resizeMenu();

                // Set our active menu to state
                this.activeNavItem = el;
                this.activeMegaMenu = menuSet;

                document.addEventListener("click", event => {
                    this.closeMenu(event);

                    this.activeNavItem = null;
                    this.activeMegaMenu = null;
                });
            }
        } else {
            // continue to our link if a megamenu doesn't exist for this page
            window.location = target.href;
        }
    }

    bindEventHandlers()
    {
        const menuLinks = [].slice.call(this.navItems);

        menuLinks.forEach(el => {
            el.addEventListener("click", event => {
                event.preventDefault();
                event.stopPropagation(el);
                this.toggleNav(el, event);
            });
        });

        document.addEventListener("click", event => {
            this.closeMenu(event);
        });
    }
}

export default MegaMenuNavigation;
